interface RagIntegrationsProps {}

// Used in EE
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RagIntegrations = (props: RagIntegrationsProps) => {
  return null;
};
